import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, setDoc, updateDoc, query, startAfter, limit, getDocs } from 'firebase/firestore';
import { firestore, functions, sendEmail } from './../../FirebaseUtils';
import { httpsCallable } from "firebase/functions";
import { Card, Button, Alert } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

function AdminNewsCard(props) {

    const [ editMode, setEditMode ] = useState();

    const [ startDateValue, setStartDateValue ] = useState(new Date());
    const [ endDateValue, setEndDateValue ] = useState(new Date());

    const [ sending, setSending ] = useState(false);
    const [ totalEmailsSent, setTotalEmailsSent ] = useState(0);

    const activeRef = useRef();
    const headerRef = useRef();
    const descriptionRef = useRef();

    const fetchEmailLimit = 20;

    useEffect(() => {
        setStartDateValue(props.startDate ? props.startDate : new Date());
        setEndDateValue(props.endDate ? props.endDate : new Date());
    }, []);

    function onClickDeleteButton(e) {
        if (!window.confirm(`คุณต้องลบข่าวสารนี้ใช่หรือไม่\n\nหัวข้อ: ${props.header}\n\nคำเตือน: เมื่อลบแล้วจะไม่สามารถกู้คืนได้`)) {
            return;
        }

        if (props.deleteNews) {
            props.deleteNews(props.id);
        }
    }

    function onClickEditButton(e) {
        setEditMode(true);
    }

    function onClickCancelButton(e) {
        setEditMode(false);
    }

    function onClickSaveButton(e) {
        if (!window.confirm(`คุณต้องบันทึกข่าวสารนี้ใช่หรือไม่\n\nหัวข้อ: ${headerRef.current.value.trim()}`)) {
            return;
        }

        if (!activeRef.current.checked && !props.active) {
            console.log('about to confirm')
            if (window.confirm(`คุณต้องการเปิดการใช้งานข่าวสารนี้ทันทีใช่หรือไม่`)) {
                activeRef.current.checked = true;
            }
        }

        setEditMode(false);

        if (props.saveNews) {
            // Replace spaces with newline characters
            const newsDescription = descriptionRef.current.value.trim().replace(/\n/g, '\n');

            const startDate = new Date(startDateValue);
            const endDate = new Date(endDateValue);

            props.saveNews(
                props.id, 
                activeRef.current.checked,
                headerRef.current.value.trim(),
                newsDescription,
                formatDate(startDate),
                formatDate(endDate),
            );
        }
    }

    function formatDate(d) {
        return `${d.getFullYear()}-${('0'+(d.getMonth()+1).toString()).slice(-2)}-${('0'+d.getDate()).slice(-2)} ${('0'+d.getHours()).slice(-2)}:${('0'+d.getMinutes()).slice(-2)}:${('0'+d.getSeconds()).slice(-2)}`;
    }

    async function onClickSendEmailToAllButton(e) {
        if (props.header === undefined || props.header.length === 0) {
            window.alert('กรุณาระบุหัวข้อ');
            return;
        }

        if (props.description === undefined || props.description.length === 0) {
            window.alert('กรุณาระบุข้อควม');
            return;
        }

        if (!window.confirm(`คุณต้องการส่งอีเมล์ให้ทุกคนในระบบใช่หรือไม่`)) {
            return;
        }

        setSending(true);
        setTotalEmailsSent(0);

        let lastVisible = null;
        let done = false;
        let i = 0;
        let total = 0;

        while (!done) {
            try {
                let q;
                if (lastVisible) {
                    // If we have a lastVisible document, start after it
                    q = query(
                        collection(firestore, 'users'),
                        startAfter(lastVisible),
                        limit(fetchEmailLimit)
                    );
                }
                else {
                    // Initial fetch, just limit to 2
                    q = query(collection(firestore, 'users'), limit(fetchEmailLimit));
                }
                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    done = true;
                }
                else {
                    const emails = querySnapshot.docs.map((doc) => doc.data().email);

                    console.log(`[${i}] => ${emails}`);
                    await sendEmails(emails);

                    total = total + emails.length;
                    setTotalEmailsSent(total);
                    
                    lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]; // Update lastVisible
                }
            }
            catch (error) {
                console.error("Error fetching users:", error);

                done = true;
            }
            finally {
                console.log("finally");
            }

            i = i + 1;
        }

        setSending(false);

        // const emails = "charuwan@gmail.com,charuwan_s@hotmail.com";
        // await sendEmails(emails);
    }

    async function onClickSendEmailToEmployeesButton(e) {
        if (props.header === undefined || props.header.length === 0) {
            window.alert('กรุณาระบุหัวข้อ');
            return;
        }

        if (props.description === undefined || props.description.length === 0) {
            window.alert('กรุณาระบุข้อควม');
            return;
        }

        if (!window.confirm(`คุณต้องการส่งอีเมล์ให้พนักงานทุกคนใช่หรือไม่`)) {
            return;
        }

        setSending(true);
        setTotalEmailsSent(0);

        let lastVisible = null;
        let done = false;
        let i = 0;
        let total = 0;

        while (!done) {
            try {
                let q;
                if (lastVisible) {
                    // If we have a lastVisible document, start after it
                    q = query(
                        collection(firestore, 'employees'),
                        startAfter(lastVisible),
                        limit(fetchEmailLimit)
                    );
                }
                else {
                    // Initial fetch, just limit to 2
                    q = query(collection(firestore, 'employees'), limit(fetchEmailLimit));
                }
                const querySnapshot = await getDocs(q);

                if (querySnapshot.empty) {
                    done = true;
                }
                else {
                    const emails = querySnapshot.docs.map((doc) => doc.data().email);

                    console.log(`[${i}] => ${emails}`);
                    await sendEmails(emails);

                    total = total + emails.length;
                    setTotalEmailsSent(total);
                    
                    lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]; // Update lastVisible
                }
            }
            catch (error) {
                console.error("Error fetching users:", error);

                done = true;
            }
            finally {
                console.log("finally");
            }

            i = i + 1;
        }

        setSending(false);
    }

    async function sendEmails(toEmails) {

        if (toEmails === undefined || !toEmails) {
            return;
        }

        const sendEmail = httpsCallable(functions, 'sendEmail');

        const data = {
            fromName: "PAT META",
            fromEmail: "no-reply@pat-meta.com",
            toEmails: toEmails.join(","),
            subject: props.header,
            text: props.description,
        };

        try {
            const result = await sendEmail(data); // Pass the email as data

            await onEmailsSent();

            console.log('Email sent successfully to ', toEmails, ':', JSON.stringify(result)); // result.data);
        } 
        catch (error) {
            console.error('Error sending email:', error);
        }
    }

    async function onEmailsSent() {
        const docRef = doc(firestore, 'news', props.id);
        try {
            await updateDoc(docRef, {
                sent: true,
            });
        }
        catch (error) {
            console.error('Error updating news: ', error);
        }
    }

    function formatDisplayDate(d) {
        const dt = new Date(d);

        const months = [ 'JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC' ];

        return `${dt.getDate()}-${months[dt.getMonth()]}-${dt.getFullYear()} ${('0'+dt.getHours()).slice(-2)}:${('0'+dt.getMinutes()).slice(-2)}:${('0'+dt.getSeconds()).slice(-2)}`;
    }

    const WIDTH = '800px';
    const DATETIME_PICKER_FORMAT = 'dd-MM-y h:mm:ss a';
    const DESCRIPTION_HEIGHT = '100px';

    return (
        <Card style={{ border: editMode ? '5px solid orange' : null }}>
            <Card.Header>
                <div style={{ width: WIDTH, display: 'flex', flex: '1', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
                    <input className='me-2' type="checkbox" defaultChecked={props.active} disabled={!editMode} ref={activeRef} style={{ width: '20px', height: '20px' }} />
                    {
                        editMode ?
                            <input type="text" defaultValue={props.header} style={{ width: WIDTH }} ref={headerRef} />
                        :
                            props.header ? props.header : null
                    }
                </div>
            </Card.Header>
            <Card.Body>
                <div className='mb-3'>
                    สถานะ: { props.active ? <span style={{ color: 'blue' }}>เปิดการใช้งาน</span> : <span style={{ color: 'red' }}>ปิดการใช้งาน</span> }
                </div>
                <div className='mb-3' style={{ width: WIDTH, display: 'flex', flex: '1', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div>เริ่มต้น {editMode ? <DateTimePicker format={DATETIME_PICKER_FORMAT} onChange={setStartDateValue} value={startDateValue} /> : formatDisplayDate(startDateValue)}</div>
                    <div>สิ้นสุด {editMode ? <DateTimePicker format={DATETIME_PICKER_FORMAT} onChange={setEndDateValue} value={endDateValue} /> : formatDisplayDate(endDateValue)}</div>
                </div>
                <div className='mb-3' style={{ width: WIDTH, border: '1px solid #ddd', borderRadius: '3px', height: DESCRIPTION_HEIGHT }}>
                {
                    editMode ?
                        <textarea type="text" defaultValue={props.description} style={{ width: WIDTH, height: DESCRIPTION_HEIGHT }} ref={descriptionRef} />
                    :
                        <pre>{ props.description ? props.description : null }</pre>
                }
                </div>
                <div style={{ width: WIDTH, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                    <div>
                        { editMode ? null : <Button className='me-1' variant='outline-warning' size='sm' onClick={onClickEditButton}>แก้ไข</Button> }
                        { editMode ? null : <Button className='me-1' variant='outline-danger' size='sm' onClick={onClickDeleteButton}>ลบ</Button> }
                        { editMode ? <Button className='me-1' variant='primary' size='sm' onClick={onClickSaveButton}>Save</Button> : null }
                        { editMode ? <Button className='me-1' variant='outline-primary' size='sm' onClick={onClickCancelButton}>Cancel</Button> : null }
                    </div>
                    <div>
                        { editMode || sending || props.sent ? null : <Button variant='outline-primary' size='sm' onClick={onClickSendEmailToAllButton}>ส่งอีเมล์ให้ทุกคน</Button> }
                        &nbsp;
                        { editMode || sending || props.sent ? null : <Button variant='outline-primary' size='sm' onClick={onClickSendEmailToEmployeesButton}>ส่งอีเมล์ให้พนักงาน</Button> }

                        { sending ? <span style={{ width: '300px', backgroundColor: 'lightBlue' }}>กำลังส่งอีเมล์... จัดส่งแล้วจำนวน {totalEmailsSent} อีเมล์</span> : null }
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

export default AdminNewsCard;
